import { finishGame3, submitGame3 } from '../../../api/game';
import { stages } from '../../../lib/Problem';
import { useCurrentUser } from '../../../redux/selectors/authSelectors';
import StageTitle from '../../../static/png/Stage_title.png';
import ResultImg from '../../../static/svg/result.svg';
import { faStopwatch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  CTResultScore,
  CommonBG,
  Mission,
  Overlay,
  MainButton as _Button,
  OverlayContent as _OverlayContent,
} from '@riddler-co-jp/specc-ui-components';
import * as React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useStatePersist as useState } from 'use-state-persist';

interface ResultPageProps {
  onBack?: () => void;
}

const ResultPage: React.FC<ResultPageProps> = props => {
  const location = useLocation();
  const { eventId } = useParams<'eventId'>();
  const uid = useCurrentUser()?.uid;
  const localRecordName = (name: string) => `${eventId}-${uid}-${name}`;
  const [params] = useState<(number | null)[]>(
    localRecordName('correctTimes'),
    []
  );
  const [showOverlay, setShowOverlay] = React.useState(-1);
  const [score, setScore] = React.useState(0);
  const maxScore = stages.length;

  const toTop = () => {
    window.location.href =
      'https://specc-dev.riddler.co.jp/events/' + eventId + '/stages';
  };
  const user = useCurrentUser();

  React.useEffect(() => {
    if (params == null) return;
    if (eventId == null) return;

    let _score = 0;
    params.forEach(single => {
      if (single != null) _score++;
    });
    setScore(_score);
    if (user == null) return;
    submitGame3(eventId, user.uid, {
      answers: params,
      totalScore: _score,
    });
    finishGame3(eventId, user.uid);
  }, [params]);

  return (
    <CommonBG>
      <Overlay
        isVisible={showOverlay >= 0}
        onClick={() => {
          setShowOverlay(-1);
        }}
      >
        {showOverlay >= 0 && (
          <OverlayContent>
            <img src={stages[showOverlay].image} />
            <p>
              <b>?</b>
              {stages[showOverlay].title}
            </p>
          </OverlayContent>
        )}
      </Overlay>
      <ResultHeader>
        <img src={ResultImg} />
      </ResultHeader>
      <Rule>
        <Title src={StageTitle} />
        <Mission>
          制限時間以内にできるだけ多くの
          <br />
          ナゾを解きなさい。
        </Mission>
        <Time>
          <FontAwesomeIcon icon={faStopwatch} />
          制限時間 8分
        </Time>
        <VideoWrapper>
          <video controls>
            <source
              src={
                'https://storage.googleapis.com/specc-ct-movie/1-1Switch_%E3%83%AB%E3%83%BC%E3%83%AB%E8%AA%AC%E6%98%8E.mp4'
              }
              type='video/mp4'
            />
            <p>Your browser doesn't support HTML5 video.</p>
          </video>
        </VideoWrapper>
        <CTResultScore score={score} maxScore={maxScore} />
        <Description>
          <h2>あなたの解答</h2>
          <ListWrapper>
            <ListHeader>
              <p>問題</p>
              <p>解答タイム</p>
            </ListHeader>
            {params?.map((single, i) => {
              return (
                <SingleList key={`res-${i}`}>
                  <StageNum>{i + 1}</StageNum>
                  <Example
                    onClick={() => {
                      setShowOverlay(i);
                    }}
                  >
                    <img src={stages[i].image} />
                  </Example>
                  {single == null ? (
                    <>
                      {i == params.length - 1 ? (
                        <ResultSec style={{ opacity: 0.3 }}>(未解答)</ResultSec>
                      ) : (
                        <ResultSec style={{ opacity: 0.3 }}>
                          (スキップ)
                        </ResultSec>
                      )}
                    </>
                  ) : (
                    <ResultSec style={{ fontSize: '3.0rem' }}>
                      <Correct />
                      {single}秒
                    </ResultSec>
                  )}
                </SingleList>
              );
            })}
          </ListWrapper>
        </Description>
        <Buttons>
          <Button color='negative' size='large' onClick={() => toTop()}>
            ステージ選択へ
          </Button>
        </Buttons>
      </Rule>
    </CommonBG>
  );
};
const Correct = () => {
  return (
    <svg
      id='Component_-_Complete'
      data-name='Component - Complete'
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
    >
      <path
        id='パス_206'
        data-name='パス 206'
        d='M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z'
        fill='#05aa70'
      />
      <path
        id='Checkbox'
        d='M4.6,8,0,3.4l.933-.933L4.6,6.067,10.667,0,11.6.933Z'
        transform='translate(4.001 6)'
        fill='#fff'
      />
    </svg>
  );
};

const OverlayContent = styled(_OverlayContent)`
  img {
    width: 600px !important;
  }

  p {
    width: 600px !important;
  }

  b {
    color: white;
    font-size: 2rem;
    font-weight: bold;
    background: #d53220;
    padding: 2px 20px;
    margin-right: 10px;
  }
`;

const ResultSec = styled.div`
  flex: 0.9;
  font-weight: bold;
  display: flex;
  align-items: center;

  svg {
    margin-right: 10px;
  }
`;

const Example = styled.div`
  flex: 1;
  display: flex;
  cursor: pointer;

  img {
    width: 200px;
    height: auto;
    margin: 10px;
    border: 1px solid #ced4da;
  }

  > div:last-child {
    font-weight: bold;
    font-size: 1.8rem;
    display: flex;
    align-items: center;
    width: 300px;

    p {
      margin: 10px;
    }
  }
`;
const StageNum = styled.div`
  margin-top: 10px;
  margin-left: 10px;
  background: #343a40;
  color: white;
  font-size: 2rem;
  font-weight: bold;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SingleList = styled.div`
  display: flex;
  position: relative;

  &:nth-child(2n) {
    background: #ffffff;
  }

  &:nth-child(2n-1) {
    background: #f3f4f6;
  }
`;
const ListWrapper = styled.div`
  border: 1px solid #ced4da;
  overflow: hidden;
  transition: 0.2s;
`;

const ListHeader = styled.div`
  display: flex;
  background: #f3f4f6;
  font-weight: bold;
  font-size: 1.8rem;
  padding: 12px;

  >p: nth-child(1) {
    flex: 1;
    padding-left: 50px;
  }
  >p: nth-child(2) {
    flex: 0.9;
  }
`;
const ResultHeader = styled.div`
  border-bottom: 4px solid #189bf2;
  margin: 0 3rem;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  img {
    margin: 2.4rem 0;
    width: 212px;
    height: 32px;
  }
`;

const Time = styled.div`
  background: rgba(206, 212, 218, 0.25);
  font-size: 1.8rem;
  font-weight: bold;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 4px 12px;
  margin-top: -1rem;

  svg {
    margin-right: 4px;
  }
`;

const VideoWrapper = styled.div`
  width: 100%;
  margin: 1rem auto;
  border: solid 2px #6c7680;

  video {
    width: 100%;
    margin-bottom: -4px;
  }
`;

const Title = styled.img`
  display: block;
  height: 80px;
  width: auto;
  margin: 4rem auto 0;
`;

const Button = styled(_Button).attrs({
  variant: 'main',
})`
  max-width: 47%;
  margin: 0 1rem;

  &:last-child {
    margin-right: 0;
  }
`;

const Buttons = styled.div`
  height: 6rem;
  display: flex;
  justify-content: center;
  margin: 0 auto 10rem;
  margin-top: 2rem;
`;

const Rule = styled.div`
  width: 720px;
  margin: 6rem auto;
  margin-top: 0;
  display: block;
`;

const Description = styled.div`
  padding: 2rem;
  font-size: 1.6rem;
  width: 100%;
  position: relative;
  margin: 0 auto;
  ul {
    margin-left: 2rem;
  }

  li {
    margin-bottom: 1.4rem;
  }

  b {
    border-bottom: 1px solid black;
  }

  h2 {
    font-size: 2.8rem;
    margin-bottom: 1rem;
  }
`;

export default ResultPage;
